import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BrandAdBanner } from "@/components/Brand/BrandAdBanner";
import { useBrandStore } from "@/components/Brand/BrandProvider";
import BrandSearchBar from "@/components/Brand/Products/BrandSearchBar";
import BrandCategory from "@/components/Brand/Products/Category/BrandCategory";
import ProductSwiper from "@/components/Brand/Products/ProductSwiper";
import useSearchBarHandler, { routerOptions } from "@/components/Brand/Products/Search/useSearchBarHandler";
import useBrandAllSearch from "@/components/Brand/Products/useBrandAllSearch";
import { EmptyWrapper } from "@/components/Coupons/Mypage/EmptyWrapper";
import { PreviewDialogProvider } from "@/components/Search/PreviewDialogProvider";
import { withBrandLayout } from "@/modules/lab/components/BrandLayout";
import { BRAND_SEARCH_PAGE } from "@/settings/constant";
import { Box, Divider, styled } from "@mui/material";
import { useRouter } from "next/router";
import { useCallback, useEffect } from "react";
const AuthorProductPage = ()=>{
    const name = useBrandStore((state)=>state.brand.name);
    const { push  } = useRouter();
    const { availableSubjectList , subjectBundle  } = useBrandAllSearch();
    const { keyword , setKeyword , currentSubject , handleMenuChangeHandler , handleSearchSubmitClick  } = useSearchBarHandler({
        useAsPath: true
    });
    const onAllProductButtonClick = useCallback((subject)=>{
        push("".concat(BRAND_SEARCH_PAGE(name), "?subject=").concat(subject), undefined, routerOptions);
    }, [
        name
    ]);
    // 운영중인 과목이 한개일때
    useEffect(()=>{
        if (availableSubjectList.length === 1) {
            handleMenuChangeHandler(availableSubjectList[0]);
        }
    }, [
        availableSubjectList,
        handleMenuChangeHandler
    ]);
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsx(BrandAdBanner, {}),
            subjectBundle.length > 0 ? /*#__PURE__*/ _jsxs(PreviewDialogProvider, {
                children: [
                    /*#__PURE__*/ _jsx(BrandSearchBar, {
                        keyword: keyword,
                        handleKeyword: (q)=>setKeyword(q),
                        currentSubject: currentSubject,
                        handleMenu: availableSubjectList,
                        handleMenuChange: handleMenuChangeHandler,
                        submit: handleSearchSubmitClick
                    }),
                    /*#__PURE__*/ _jsx(BrandCategory, {
                        isStyledRadius: true
                    }),
                    /*#__PURE__*/ _jsx(Divider, {}),
                    subjectBundle.map((result, index)=>{
                        return /*#__PURE__*/ _jsx(ProductSwiper, {
                            routerChange: ()=>onAllProductButtonClick(result.subject),
                            ...result
                        }, index);
                    })
                ]
            }) : /*#__PURE__*/ _jsx("div", {
                style: {
                    padding: "0 20px"
                },
                children: /*#__PURE__*/ _jsx(EmptyWrapper, {
                    description: "등록된 상품이 없어요."
                })
            })
        ]
    });
};
const Container = styled("div")((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "40px",
        overflowX: "hidden",
        [theme.breakpoints.down("lg")]: {
            gap: "32px"
        },
        [theme.breakpoints.down("sm")]: {
            gap: "28px"
        }
    };
});
export var __N_SSP = true;
export const StyleBox = styled(Box)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        flexDirection: "column",
        gap: "40px",
        padding: "0px 0 12px 0",
        [theme.breakpoints.down("lg")]: {
            padding: "0px 32px 0px 32px",
            gap: "32px"
        },
        [theme.breakpoints.down("sm")]: {
            padding: "0px 20px 0px 20px",
            gap: "28px"
        }
    };
});
export default withBrandLayout(AuthorProductPage);
